module.exports = __webpack_public_path__ + "static/img/核算通_定制包_封面.652949b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/核算通_定制包_封面.jpg
// module id = vskn
// module chunks = 1